(() => {
  const start = async () => {
    const root = document.querySelector('[data-ltz-native]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('[data-ltz-dialog]');
    root.addEventListener('click', event => {
      if (event.target.closest('[data-ltz-connect]')) dialog.showModal();
      if (event.target.closest('[data-ltz-close]') || event.target === dialog) dialog.close();
    });
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) root.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin) { url.searchParams.set('preview_theme_id', preview); link.href = url.pathname + url.search + url.hash; }
    });
    const extras = root.querySelector('[data-ltz-extras]');
    const cuts=root.querySelector('[data-cts-root]');
    if(cuts){
      const response=await fetch(root.dataset.catalog),catalog=await response.json(),p=catalog.find(p=>p.id===root.dataset.productId);
      if(p){
        const maxLength=Math.floor(Math.min(p.maxLength,72/p.watts)*1000/p.increment)*p.increment/1000;
        const liveResponse=await fetch((window.Shopify?.routes?.root || '/')+'products/'+p.handle+'.js');
        if(!liveResponse.ok)throw Error('Unable to check strip availability');
        const live=await liveResponse.json();
        p.variants=live.variants;
        const addToCart=async items=>{
          if(extras?.itemsFor){const selected=extras.itemsFor(items[0]);if(selected)items=selected;}
          if(items.some(i=>!Number.isInteger(i.quantity)||i.quantity<1))throw Error('Please enter a whole quantity for each accessory.');
          const sections=[...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId).slice(0,5);
          const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items,sections:sections.join(',')})});
          const result=await response.json();if(!response.ok)throw Error(result.description||'Unable to add these items.');
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{data:{source:'product-form-component',itemCount:items.reduce((n,i)=>n+i.quantity,0),sections:result.sections}}}));
          document.querySelector('cart-drawer-component')?.open?.();
        };
        let currentVariant;
        const configure=variant=>{currentVariant=variant;window.initialiseLighteezCuts(cuts,{price:variant.price,variant:variant.id,increment:p.increment,maxLength,parentSku:p.parentSku,orderable:variant.available,addToCart});};
        const selectedId=new URLSearchParams(location.search).get('variant')||root.querySelector('[data-ltz-selected-variant]')?.dataset.ltzSelectedVariant;
        configure(p.variants.find(v=>String(v.id)===String(selectedId))||p.variants[0]);
        window.addEventListener('mainVariantChange',event=>{const v=p.variants.find(v=>String(v.id)===String(event.detail.variantId));if(v)configure(v);});
        const params=new URLSearchParams(location.search);
        try {
          if(params.has('cuts')){
            const lengths=JSON.parse(params.get('cuts'));
            if(Array.isArray(lengths)&&lengths.length>0&&lengths.length<=5&&lengths.every(n=>Number.isFinite(n)&&n>=p.increment/1000&&n<=maxLength&&Math.abs(n*1000/p.increment-Math.round(n*1000/p.increment))<0.000001)){
              cuts.querySelector('[data-cts-toggle="cut"]').click();
              lengths.forEach((n,i)=>{if(i)cuts.querySelector('[data-cts-add-row]').click();const input=cuts.querySelectorAll('[data-cts-length]')[i];input.value=n.toFixed(2);input.dispatchEvent(new Event('input',{bubbles:true}));});
            }
          } else if(params.has('length')) {
            const n=Number(params.get('length'));
            if(Number.isInteger(n)&&n>=1&&n<=Math.floor(maxLength)){const input=cuts.querySelector('[data-cts-qty]');input.value=String(n);input.dispatchEvent(new Event('input',{bubbles:true}));}
          }
        } catch {}
        const selectedExtensions=()=>{
          if(!extras?.querySelector('[data-extra-index]:checked'))return 0;
          return Number(extras.querySelector('[data-extra-qty]').value);
        };
        const updateDestination=link=>{
          const destination=new URL(link.href,location.origin),lengths=cuts.getCuts();
          if(!lengths.length)return false;
          const extensions=selectedExtensions();
          if(!Number.isInteger(extensions)||extensions<0||extensions>99)return false;
          if(link.matches('.ltz-kit-link')){
            destination.searchParams.set('variant',currentVariant.id);
            destination.searchParams.set('cuts',JSON.stringify(lengths));
          }else if(cuts.querySelector('[data-cts-panel="metre"]').hidden){
            destination.searchParams.delete('length');destination.searchParams.set('cuts',JSON.stringify(lengths));
          }else{
            destination.searchParams.delete('cuts');destination.searchParams.set('length',String(lengths[0]));
          }
          destination.searchParams.set('extensions',String(extensions));
          link.href=destination.pathname+destination.search+destination.hash;
          return true;
        };
        root.addEventListener('click',event=>{
          const link=event.target.closest('[data-ltz-colour-link],.ltz-kit-link');
          if(!link)return;
          if(!updateDestination(link)&&link.matches('.ltz-kit-link')){event.preventDefault();cuts.querySelector('[data-cts-status]').textContent='Please enter valid strip lengths and accessory quantities before building your kit.';}
        });

      }
    }
    if (!extras) return;
    const esc = text => String(text ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const money = price => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(price / (document.documentElement.dataset.vatMode === 'ex' ? 120 : 100));
    const vat = () => document.documentElement.dataset.vatMode === 'ex' ? 'EX VAT' : 'INC VAT';
    let accessories = [], expected = [];
    try {
      const response = await fetch(root.dataset.catalog);
      if (!response.ok) throw Error('Catalogue unavailable');
      const catalog = await response.json(), product = catalog.find(p => p.id === root.dataset.productId);
      const skus = [product.cableSku, 'CAB-EXT-D-2M'].filter(Boolean);
      if (product.sku === 'PRO-LED-05-2M') skus.push('PRO-LED-05-CON', 'PRO-LED-O5-JOIN');
      accessories = await Promise.all(skus.map(async sku => {
        const p = catalog.find(p => p.variants.some(v => v.sku === sku));
        if (!p) return null;
        const r = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + p.handle + '.js');
        if (!r.ok) return null;
        const live = await r.json(), v = live.variants.find(v => v.sku === sku);
        return v ? {sku, name:sku==='CAB-EXT-D-2M'?'2m Dupont extension cable · extra reach':sku===product.cableSku?'Extra 2m matching input cable':live.title.replace(/^Lighteez\s*/,''), image:p.image, v} : null;
      }));
      accessories = accessories.filter(Boolean);
      if (!accessories.length) return;
      extras.querySelector('[data-ltz-accessories]').innerHTML = accessories.map((a,i) => `<div class="ltz-extra-row"><label><input type="checkbox" data-extra-index="${i}" ${a.v.available?'':'disabled'}><img src="${esc(a.image)}" alt="" width="60" height="60" loading="lazy"><span><b>${esc(a.name)}</b><small>${esc(a.sku)}</small><span data-extra-price="${i}"></span>${a.v.available?'':'<small>Currently unavailable</small>'}</span></label><label class="ltz-extra-qty">Quantity<input type="number" min="1" max="99" step="1" value="1" data-extra-qty="${i}" disabled aria-label="Quantity of ${esc(a.name)}"></label></div>`).join('');
      const selected = () => [...extras.querySelectorAll('[data-extra-index]:checked')].map(input => ({a:accessories[Number(input.dataset.extraIndex)], qty:Number(extras.querySelector(`[data-extra-qty="${input.dataset.extraIndex}"]`).value)}));
      function totals() {
        extras.querySelectorAll('[data-extra-price]').forEach(el => { el.textContent = money(accessories[Number(el.dataset.extraPrice)].v.price) + ' ' + vat(); });
        const picks=selected(), total=picks.reduce((sum, p) => sum + p.a.v.price * p.qty, 0);
        extras.querySelector('[data-ltz-extra-total]').textContent = picks.length ? 'Selected extras: ' + money(total) + ' ' + vat() : 'No extras selected — your light already includes its lead.';
      }
      extras.addEventListener('change', event => {
        if (event.target.matches('[data-extra-index]')) {
          const qty=extras.querySelector(`[data-extra-qty="${event.target.dataset.extraIndex}"]`);
          qty.disabled=!event.target.checked; qty.required=event.target.checked;
        }
        totals();
      });
      extras.addEventListener('input',totals);
      extras.itemsFor = main => {
        const picks=selected();
        if (!picks.length) {expected=[];return null;}
        expected = picks.map(p => ({id:p.a.v.id,quantity:p.qty}));
        return [main,...expected];
      };
      extras.linesAdded = response => expected.every(wanted => (response.items || []).some(item => Number(item.variant_id || item.id) === Number(wanted.id) && item.quantity >= wanted.quantity));
      extras.missingText = 'Some selected extras were not confirmed. Please check your basket before trying again.';
      extras.explainFailure = async message => message + ' Check the basket quantities before adding again.';
      const requestedExtensions=Number(new URLSearchParams(location.search).get('extensions'));
      const extensionIndex=accessories.findIndex(a=>a.sku==='CAB-EXT-D-2M');
      if(cuts&&extensionIndex>=0&&Number.isInteger(requestedExtensions)&&requestedExtensions>0&&requestedExtensions<=99&&accessories[extensionIndex].v.available){
        const checkbox=extras.querySelector(`[data-extra-index="${extensionIndex}"]`),quantity=extras.querySelector(`[data-extra-qty="${extensionIndex}"]`);
        checkbox.checked=true;quantity.disabled=false;quantity.required=true;quantity.value=String(requestedExtensions);
      }
      extras.hidden=false;totals();window.addEventListener('vatPreferenceChanged',totals);
    } catch { extras.hidden=false;extras.querySelector('[data-ltz-accessories]').textContent='Optional accessories could not load. Refresh to try again. Your light still includes its lead.'; }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
